import React, { memo } from "react";

import { Box, Preloader, Text } from "@origin-digital/ods-core";

import { StyledHeading } from "./StyledHeading";

type PreloaderScreenProps = {
  id: string;
  heading: string;
  description?: string;
};

export const PreloaderScreen = memo(
  ({ id, heading, description }: PreloaderScreenProps) => {
    return (
      <>
        <div>
          <Box
            alignItems="center"
            data-id={id}
            display="flex"
            justifyContent="center"
            marginTop="xxxlarge"
            marginBottom="xxxlarge"
          >
            <Preloader />
          </Box>
          <StyledHeading variant="h1">{heading}</StyledHeading>
        </div>
        <br />
        <Text>{description}</Text>
      </>
    );
  }
);
